import { ProfileTranslationsUk } from '../Pages/Profile/translations/uk';

export const UserPageTranslationsUk = { profilePage: ProfileTranslationsUk };
